import { Outlet } from "react-router-dom";

import {
  bgImage,
  CarouselImage1,
  CarouselImage2,
  CarouselImage3,
} from "@zenith/features/Authentication";
import { CarouselComponent } from "@zenith/components";
import ZenithLogo from "@zenith/assets/icons/ZenithLogo";
import { getCopyright } from "@zenith/utils";
import { memo } from "react";

/* eslint-disable-next-line */
export interface AuthenticationLayoutProps {}

const AuthenticationLayout = memo(function AuthenticationLayout(
  props: AuthenticationLayoutProps
) {
  const slides = [
    {
      url: CarouselImage1,
      title: "Simple analytics",
      description:
        "Understand your business performance with smart sales and inventory insights.",
    },
    {
      url: CarouselImage2,
      title: "Instant Settlement",
      description:
        "Get paid instantly, no matter how your customers pay – Cash, POS, Payment link, QR, USSD or bank transfers.",
    },
    {
      url: CarouselImage3,
      title: "Multi-User POS",
      description:
        "Set up multiple points of sale and empower your team to collect payments securely.",
    },
  ];

  const containerImage = {
    backgroundImage: `url(${bgImage})`,
    backgroundRepeat: "no-repeat", // Prevent background from repeating
    backgroundSize: "cover", // Make the background image cover the entire width and adjust height accordingly
    backgroundPosition: "center", // Center the background image
  };

  return (
    <div className="flex min-h-screen">
      <div
        style={containerImage}
        className="relative hidden flex-1 flex-col items-center justify-center lg:flex"
      >
        <div className="my-16">
          <ZenithLogo width="86.4px" height="88px" />
        </div>
        <CarouselComponent slides={slides} />
        <div className=" text-center text-white">{getCopyright()}</div>
      </div>
      <div
        className={`flex w-full flex-1 grow flex-col items-center justify-center px-3 md:px-0`}
      >
        <Outlet />
      </div>
    </div>
  );
});

export default AuthenticationLayout;
